import { GENDER, LANG, NAME_PART_TYPE, ORDER } from '../../constants'

// This object represents the minimum data needed to display a
// print-and-share pedigree person.
export default Object.freeze({
  canUserEdit: true, // Can the CURRENT user edit this person
  gender: GENDER.unknown,
  id: null, // If null, this person is not in the tree database
  living: true,
  name: '',
  primaryNameForm: {
    fullText: '',
    lang: LANG.traditional,
    order: ORDER.eastern, // (lastName firstName)
    parts: [
      {
        type: NAME_PART_TYPE.prefix,
        value: '',
      },
      {
        type: NAME_PART_TYPE.given,
        value: '',
      },
      {
        type: NAME_PART_TYPE.surname,
        value: '',
      },
      {
        type: NAME_PART_TYPE.suffix,
        value: '',
      },
    ],
    separator: '', // No space for Eastern style, use a space for Western style
  },
})
